import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import logo from "../../assets/img/retail-logo-trans.png";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import useGlobalState from "../../Context";
import { logout, setIsLoggedIn } from "../../reducer/action";
import { useNavigate } from "react-router-dom";
const Unauthorized = () => {
  const navigate = useNavigate();
  const [, dispatch] = useGlobalState();

  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();

  const logoutSignUp = async () => {
    try {
      setLoading(true);
      await dispatch(setIsLoggedIn(false));
      await dispatch(logout());
      navigate("/login")
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to Logout");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box className="App" display={"flex"} justifyContent="center">
        <Paper sx={{ m: 7, py: 2 }}>
          <Box fullWidth>
            <Box display={"flex"} justifyContent="start">
              <div className="logoContainer">
                <img
                  src={logo}
                  alt="reliance retail"
                  title="dock appointment"
                  width="90"
                  height="45"
                />
                <div className="projectLogo fontSize20">
                  <div title="Docker Appointment" className="navBarTitle">
                    Dock Appointment System
                  </div>
                </div>
              </div>
            </Box>
            <Divider />
            <Box sx={{ px: 2, pt: 3 }}>
              <Grid
                container
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Grid item>
                  <Typography variant="h6" color={"#4d6fa5"}>
                    Confirm Logout
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Grid container sx={{ px: 2, m: 2 }}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  You are already logged in, you need to logout before logging
                  in. Are you sure you want to logout other device?
                </Typography>
              </Grid>
            </Grid>
            <Grid container display={"flex"} justifyContent="end" mb={2} mt={3}>
              {/* <Button
                variant="outlined"
                sx={{ fontSize: "13px", ml: 2 }}
                onClick={() => {}}
                color="error"
              >
                Cancel
              </Button> */}
              <Button
                variant="contained"
                sx={{
                  fontSize: "13px",
                  background: "#4d6fa5",
                  color: "#fff",
                  mx: 2,
                }}
                onClick={() => {
                  logoutSignUp();
                }}
                autoFocus
              >
                Logout
              </Button>
            </Grid>
          </Box>
        </Paper>
      </Box>
    </>
  );
};
export default Unauthorized;
